import { render, staticRenderFns } from "./kgwl.vue?vue&type=template&id=8988a2ae&scoped=true&"
import script from "./kgwl.vue?vue&type=script&lang=js&"
export * from "./kgwl.vue?vue&type=script&lang=js&"
import style0 from "./kgwl.vue?vue&type=style&index=0&id=8988a2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8988a2ae",
  null
  
)

export default component.exports